<template>
  <v-row class="accesslink-grid-view">
    <v-col class="d-flex flex-wrap py-0" offset="0" cols="12" offset-sm="1" sm="10" offset-md="2" md="8">
      <AccesslinkGridNodeItem
        v-for="node in nodes"
        :key="node.id"
        :code="code"
        :node="node"
      />
      <AccesslinkGridPodItem
        v-for="pod in pods"
        :key="pod.id"
        :code="code"
        :pod="pod"
        :currentNodeId="currentNodeId"
      />
    </v-col>
  </v-row>
</template>

<script>
import AccesslinkGridPodItem from '@/routes/accesslink2/components/grid-view/AccesslinkGridPodItem.vue';
import AccesslinkGridNodeItem from '@/routes/accesslink2/components/grid-view/AccesslinkGridNodeItem.vue';

export default {
  name: "AccesslinkGridView",
  components: { AccesslinkGridNodeItem, AccesslinkGridPodItem },
  props: {
    pods: {
      type: Array,
      required: true
    },
    nodes: {
      type: Array,
      required: true,
    },
    currentNodeId: {
      type: String,
      required: false,
    },
    code: {
      type: String,
      required: true,
    }
  }
}
</script>

<style>
.accesslink-grid-view .grid-view-item .item-name {
  width: 100%;
  font-size: 12px;
  line-height: 1.3;
}

.accesslink-grid-view .grid-view-item .item-attributes {
  font-size: 12px;
  line-height: 1.2;
  width: 164px;
}

.accesslink-grid-view .grid-view-item a,
.accesslink-grid-view .grid-view-item .accesslink-grid-item-name {
  text-decoration: none;
  font-size: 12px;
  font-weight: 600;
}

.v-theme--dark .accesslink-grid-view .grid-view-item a,
.v-theme--dark .accesslink-grid-view .grid-view-item .accesslink-grid-item-name {
  color: #FFFFFF;
}

.v-theme--light .accesslink-grid-view .grid-view-item a,
.v-theme--light .accesslink-grid-view .grid-view-item .accesslink-grid-item-name {
  color: #000000;
}

.accesslink-grid-view .grid-view-item {
  width: 224px;
  margin: 8px;
  padding: 12px;
  height: 194px;
  border-radius: 6px;
  cursor: pointer;
}

.accesslink-grid-view .grid-view-item > div {
  width: 100%;
}

.v-theme--dark .accesslink-grid-view .grid-view-item {
  background-color: rgb(var(--v-theme-tw-surface));
  /* background-color: #232b36; */
}

.v-theme--light .accesslink-grid-view .grid-view-item {
  background-color: rgb(var(--v-theme-tw-surface));
  /* background-color: #FFFFFF; */
}

.v-theme--dark .accesslink-grid-view .grid-view-item:hover {
  background-color: #373f48;
}

.v-theme--light .accesslink-grid-view .grid-view-item:hover {
  background-color: rgba(17, 17, 17, 0.1);
}

.v-theme--dark .accesslink-grid-view .grid-view-item .v-chip {
  background-color: rgba(85, 85, 85, 0.7) !important;
}

.v-theme--light .accesslink-grid-view .grid-view-item .v-chip {
  background-color: rgba(224, 224, 224, 0.7) !important;
}
</style>
